import React from 'react';
import './Footer.css';
const siteDudesLogo = '/sd_logo_480px_136px.png';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dashboard-footer">
      <img src={siteDudesLogo} alt="Site Dudes Logo" className="site-dudes-logo-footer" /><p>Copyright {currentYear} Sitedudes.com</p>
    </footer>
  );
};

export default Footer;
